/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
import React, { useEffect } from 'react';

const WIDTH = 315;
const HEIGHT = 620;

export const PaymentSDK = () => {
	const env = process.env.NODE_ENV === 'development' ? 'test' : 'production';

	// 修改輸入框樣式
	const customStyle = {
		inputStyle: {
			// 修改輸入框樣式(整體)
			fontSize: '14px',
			fontWeight: '500',
			lineHeight: '1.5',
			color: '#333',
		},
		titleStyle: {
			// 修改標題文字 (指定 creditNumber|expireDate|cvcNumber)
			title: {
				creditNumber: '信用卡號',
			},
			// 修改標題樣式 (整體)
			style: {
				color: '#333',
			},
		},
		backgroundColor: '#FFFFFF',
		minHeight: `${HEIGHT}`,
	};
	useEffect(() => {
		const sdk = typeof window !== 'undefined' ? window.NewebPaySDK : undefined;
		if (!sdk) {
			// SDK script failed to load/execute; avoid crashing the app
			console.error('NewebPaySDK is not defined. Check that the SDK script is injected and executes before React mounts.');
			return;
		}
		sdk.setCardOncePay(env, customStyle);
	}, []);

	return (
		<div className="iframe-area">
			<div id="nwp-payment-once" style={{ width: `${WIDTH}px`, height: `${HEIGHT}px` }} />
		</div>
	);
};
